import { AppState } from 'state/state.model';

import type { QuoteInfos } from '../pendings/pendings.model';
import type { QuoteResultsMap } from './result.model';

export function getQuoteResult(state: QuoteResultsMap, quoteId: string | undefined) {
  return quoteId ? state[quoteId] : undefined;
}
export function getQuoteInfos(state: QuoteResultsMap, quoteId: string | undefined): QuoteInfos | undefined {
  return quoteId ? state[quoteId] : undefined;
}

export function selectQuoteResult(state: AppState, quoteId?: string) {
  if (!quoteId) {
    return undefined;
  }
  return state.quotes?.results?.[quoteId] ?? undefined;
}
